import type { Locales } from '@/store/language.interface';
import { getLabel } from '@/utils/data-display-utils';
import { showToaster } from '@/utils/toaster-util';

/** The keys of `dialog.moderation.types` in the locale files: a key missing there would show on screen as is. */
type SavedItemType = 'vote' | 'comment' | 'proposition' | 'like' | 'feedback';

/**
 * Tells the participant that what they just sent was not saved. The text comes from the locale files and never from the
 * API's error message, which is written for developers, in English.
 */
export function showSaveErrorToast(type: SavedItemType, languageEnabled?: Locales[]) {
  showToaster({
    message: getLabel('dialog.moderation.message.error', languageEnabled, {
      named: { type: getLabel(`dialog.moderation.types.${type}`, languageEnabled) },
    }),
    type: 'negative',
  });
}
